import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from './AccentedSvgIcon';

export const ArrowUpRight = (props: AccentedSvgIconProps): JSX.Element => (
    <AccentedSvgIcon {...props} className="ue-icon-arrow-up-right">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.470207 0L16.25 0V15.7798L14.4127 15.7798V3.13648L1.29917 16.25L0 14.9508L13.1135 1.83731L0.470207 1.83731L0.470207 0Z"
        />
    </AccentedSvgIcon>
);
